import { Link } from 'react-router-dom';

interface Comic {
  id: string;
  title: string;
  author: string;
  categoryNames: string[];
  rating: number;
  views: number;
  status: string;
  coverUrl: string;
}

export default function ComicCard({ comic, size = 'normal' }: { comic: Comic; size?: 'normal' | 'small' }) {
  const isSmall = size === 'small';

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 transition-all group-hover:border-primary-300 ${isSmall ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}>
        <img
          src={comic.coverUrl}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-white'
              : 'bg-foreground-700 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>

        <div className="absolute top-2 right-2 bg-black/60 backdrop-blur-sm rounded-full px-2 py-0.5 flex items-center gap-1">
          <i className="ri-star-fill text-yellow-400 text-[10px]"></i>
          <span className="text-white text-[10px] font-medium">{comic.rating}</span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <div className="flex items-center gap-2 flex-wrap">
            {comic.categoryNames.slice(0, 2).map(name => (
              <span key={name} className="px-2 py-0.5 bg-white/20 text-white text-[10px] rounded-full whitespace-nowrap">
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className={`mt-3 ${isSmall ? 'px-1' : ''}`}>
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        <div className="flex items-center gap-3 mt-1.5">
          <span className="flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-eye-line text-[10px]"></i>
            {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}